export default function PhoneNumberSection() {
  return (
    <div className="mt-8 border-t border-color-border-input-lightmode pt-8 dark:border-color-border-input-darkmode">
      <p className="typography-product-body text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        Add your phone number to get live updates during the tournament
      </p>
      <div className="mt-2">
        <input placeholder="Phone number" className="input-form" />
      </div>
    </div>
  );
}
